var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkerBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.85 0.5 0 2.915 0 6.65C0 9.035 1.8375 11.84 5.505 15.0725C5.79 15.32 6.2175 15.32 6.5025 15.0725C10.1625 11.84 12 9.035 12 6.65C12 2.915 9.15 0.5 6 0.5ZM6 8C5.175 8 4.5 7.325 4.5 6.5C4.5 5.675 5.175 5 6 5C6.825 5 7.5 5.675 7.5 6.5C7.5 7.325 6.825 8 6 8Z",
    fill: "#00106E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkerBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marker-blue.cbbb9fa88e4f74a87330cbe6588ef257.svg";